var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import { breakpointSm } from '@sb1/ffe-core';
import { useResize } from './useResize';
// See https://www.freecodecamp.org/news/build-a-custom-pagination-component-in-react/
export var DOTS = '...';
var BREAKPOINT_SM = parseInt(breakpointSm, 10);
var range = function (start, end) {
    var length = end - start + 1;
    return Array.from({ length: length }, function (_, idx) { return idx + start; });
};
export function usePaginationRange(totalCount, pageSize, currentPage, siblingCount) {
    if (siblingCount === void 0) { siblingCount = 1; }
    var innerWidth = useResize()[0];
    return useMemo(function () {
        var totalPageCount = Math.ceil(totalCount / pageSize);
        var totalPageNumbers = siblingCount + 5;
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        var firstPageIndex = 1;
        var lastPageIndex = totalPageCount;
        if (innerWidth > BREAKPOINT_SM) {
            var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
            var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
            var shouldShowLeftDots = leftSiblingIndex > 2;
            var shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;
            if (!shouldShowLeftDots && shouldShowRightDots) {
                var leftItemCount = void 0;
                if (innerWidth <= BREAKPOINT_SM) {
                    leftItemCount = 1 + siblingCount;
                }
                else {
                    leftItemCount = 2 + 2 * siblingCount;
                }
                var leftRange = range(1, leftItemCount);
                return __spreadArray(__spreadArray([], leftRange, true), [DOTS, totalPageCount], false);
            }
            if (shouldShowLeftDots && !shouldShowRightDots) {
                var rightItemCount = void 0;
                if (innerWidth <= BREAKPOINT_SM) {
                    rightItemCount = 1 + siblingCount;
                }
                else {
                    rightItemCount = 2 + 2 * siblingCount;
                }
                var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
                return __spreadArray([firstPageIndex, DOTS], rightRange, true);
            }
            if (shouldShowLeftDots && shouldShowRightDots) {
                if (innerWidth <= BREAKPOINT_SM) {
                    return [
                        firstPageIndex,
                        DOTS,
                        currentPage,
                        DOTS,
                        lastPageIndex,
                    ];
                }
                var middleRange = range(leftSiblingIndex, rightSiblingIndex);
                return __spreadArray(__spreadArray([
                    firstPageIndex,
                    DOTS
                ], middleRange, true), [
                    DOTS,
                    lastPageIndex,
                ], false);
            }
        }
        else {
            var leftIndexMax = Math.min(totalPageCount - 2, currentPage - 1);
            var leftIndex = Math.max(leftIndexMax, 1);
            var rightIndexMin = Math.max(3, currentPage + 1);
            var rightIndex = Math.min(rightIndexMin, totalPageCount);
            return range(leftIndex, rightIndex);
        }
    }, [totalCount, pageSize, siblingCount, currentPage, innerWidth]);
}
